module.exports = __webpack_public_path__ + "img/c03_buildingtraderoutes_Normal_ua.569432d0.webp";